import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CreateSubscription from './CreateSubscription';
import MiniDrawer from '../../components/MiniDrawer';

const SubscriptionTestContainer = () => {
  const { userDetails } = useSelector((state) => ({userDetails: state.globalState.userDetails}), shallowEqual);
  const navigate = useNavigate();

  const handleSubscriptionComplete = () => {
    // After subscription is complete, navigate to settings page
    navigate('/settings');
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <MiniDrawer />
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Container>
          <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h4" gutterBottom sx={{ color: '#29C0BB', mb: 3 }}>
              Subscription
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, fontStyle: 'italic' }}>
              User ID: {userDetails.id}
            </Typography>
          </Paper>
          
          <CreateSubscription
            onSubscriptionComplete={handleSubscriptionComplete}
          />
        </Container>
      </Box>
    </Box>
  );
};

export default SubscriptionTestContainer;